import {
  Alert,
  Box,
  Button,
  Card,
  CircularProgress,
  Grid,
  IconButton,
  Modal,
  Snackbar,
  TextField,
  Typography,
} from '@mui/material'
import LoadingButton from '@mui/lab/LoadingButton'
import React, { useEffect, useState } from 'react'
import './Stacking.css'
import { ToastContainer, toast } from 'react-toastify'
import Connection from '../../../Contract'
import bigInt from 'big-integer'
import CloseIcon from '@mui/icons-material/Close'
import { useWeb3Context } from '../../../hooks/web3Context'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 450,
  boxShadow: 24,
  p: 4,
}

const Stack = () => {
  const { address: account } = useWeb3Context()
  const [openStack, setOpenStack] = React.useState(false)
  const [openUnStack, setOpenUnStack] = React.useState(false)
  const [stakerAddress, setStakerAddress] = useState('')
  const [stakerAmount, setStakerAmount] = useState()
  const [showloadingBtn, setshowloadingBtn] = useState(false)
  const [validatorName, setValidatorName] = useState('')
  const [validatorDescription, setValidatorDescription] = useState('')
  const [stakeamountWarning, setstakeamountWarning] = useState(false)
  const [dd, setdd] = useState([])
  const handleOpenUnStack = () => setOpenUnStack(true)
  const handleCloseUnStack = () => setOpenUnStack(false)
  const [startLoading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)
  const [website, setWebSite] = useState('')

  const getAmount = async (address) => {
    try {
      let result = await Connection.stakeValidatorBalance(address)
      let contact = await Connection.getContractBalance()
      let contractAmount = contact.toString()
      let amount = result.toString()
      const amountContract = contractAmount.slice(0, amount.length - 18)
      const totalamount = amount.slice(0, amount.length - 18)
      console.log(totalamount, 'amount', amountContract)
      const resultData = (amountContract / totalamount) * 100
      console.log(resultData, 'resultData')
      return amount
    } catch (error) {
      console.log(error)
    }
  }

  // const handleValidatorListDetails=(list)=>{
  //     if(list){
  //         return list.map(async(item,index)=>{
  //             return(
  //                 <>
  //                 {console.log(await getAmount(item[0]))}
  //                 {console.log(await Connection.stakeValidatorBalance(item[0]))}
  //                 {console.log(item[0],"item")}
  //                 </>
  //             )
  //         })
  //     }
  // }

  // const totalBalance=async()=>{
  //     let dataget=await Connection.stakeValidatorBalance(account)
  //     let alldetails=await Connection.getValidatorsDetails(1)
  //     console.log(dataget.toString(),"dataget")
  //     console.log(alldetails,"alldataget")
  // }

  const handleStakeSubmit = async () => {
    if (
      stakerAmount < 10 ||
      !stakerAmount ||
      validatorName == '' ||
      validatorDescription == '' ||
      website == ''
    ) {
      setstakeamountWarning(true)
      // buttons
      //   alert("Stake amount should be Greater than 10000");
      console.log('stake value')
      setOpen(true)
      //   setStakerAmount(0);
      return null
    } else if (stakerAmount >= 10) {
      setshowloadingBtn(true)

      setstakeamountWarning(false)

      try {
        setLoading(true)
        let stakerAmountData = bigInt(stakerAmount * 10 ** 18)
        console.log(stakerAmountData.value, 'stakerAmount')
        let result = await Connection.stakeValidator({
          value: stakerAmountData.value,
        })
        setOpenStack(false)
        console.log(result, 'results')
        let abc = await result.wait()
        if (abc) {
          console.log(abc, 'abc')
          setLoading(false)
          setOpenStack(false)
          postValidatorDetails()
          setStakerAmount()
          setValidatorName('')
          setValidatorDescription('')
          setWebSite('')
          toast.success('Transaction successfull')
        }
      } catch (error) {
        if(error.reason) {
          toast.error(error.reason)
        }
        setLoading(false)
        setOpenStack(false)
        setshowloadingBtn(false)
      }
    }
    setshowloadingBtn(false)
  }

  const shortenAccountId = (fullStr) => {
    const strLen = 20
    const separator = '...'

    if (fullStr?.length <= strLen) return fullStr

    const sepLen = separator.length
    const charsToShow = strLen - sepLen
    const frontChars = Math.ceil(charsToShow / 2)
    const backChars = Math.floor(charsToShow / 2)
    // console.log("return  ",fullStr?.substr(0, frontChars) +
    // separator +
    // fullStr?.substr(fullStr?.length - backChars))
    return (
      fullStr?.substr(0, frontChars) +
      separator +
      fullStr?.substr(fullStr?.length - backChars)
    )
  }

  const postValidatorDetails = () => {
    var myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')

    var raw = JSON.stringify({
      Name: validatorName,
      Address: account,
      Description: validatorDescription,
      Website: website,
    })

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    }

    fetch('https://api.dexit.network/validatorInfo', requestOptions)
      .then((response) => response.text())
      .then((result) => console.log(result))
      .catch((error) => console.log('error', error))
  }

  return (
    <>
      <ToastContainer />
      <Grid container p={1} mt={3}>
        <Card className="section-card">
          <Box sx={{ flexGrow: 1 }}>
            <Typography className="header-text">Node Validation</Typography>
            <Grid container spacing={2} pt={1}>
              <Grid item xs={12} md={6}>
                <Typography className="input-label">Staker Address</Typography>
                <TextField
                  // label="Staker Address"
                  variant="filled"
                  hiddenLabel
                  placeholder="Enter Address"
                  defaultValue={account ? shortenAccountId(account) : 'loading'}
                  value={account ? shortenAccountId(account) : 'loading'}
                  InputProps={{
                    readOnly: true,
                  }}
                  size="small"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography className="input-label">Staker Amount</Typography>
                <TextField
                  required
                  // label="Staker Amount"
                  variant="filled"
                  hiddenLabel
                  value={stakerAmount}
                  error={stakeamountWarning}
                  onChange={(e) => setStakerAmount(e.target.value)}
                  placeholder="Minimum amount 10000"
                  size="small"
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography className="input-label">Validator Name</Typography>
                <TextField
                  required
                  // label="Validator Name"
                  variant="filled"
                  hiddenLabel
                  value={validatorName}
                  error={stakeamountWarning}
                  onChange={(e) => setValidatorName(e.target.value)}
                  placeholder="Enter Address"
                  size="small"
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography className="input-label">Website</Typography>
                <TextField
                  required
                  // label="Website"
                  variant="filled"
                  hiddenLabel
                  value={website}
                  error={stakeamountWarning}
                  onChange={(e) => setWebSite(e.target.value)}
                  placeholder="Enter URL"
                  size="small"
                  fullWidth
                />
              </Grid>
            </Grid>
            <Box mt={2}>
              <Typography className="input-label">
                Validator Description
              </Typography>
              <TextField
                required
                // label="Validator Description"
                variant="filled"
                hiddenLabel
                multiline
                rows={2}
                fullWidth
                value={validatorDescription}
                error={stakeamountWarning}
                onChange={(e) => setValidatorDescription(e.target.value)}
                size="small"
              />
            </Box>

            <div className="btn_postdetails" style={{ marginTop: '1rem' }}>
              {showloadingBtn === true ? (
                <LoadingButton
                  sx={{
                    mt: 1,
                  }}
                  color="primary"
                  loading
                  variant="contained"
                  size="large"
                >
                  Submit
                </LoadingButton>
              ) : (
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ mt: 1 }}
                  size="large"
                  onClick={() => handleStakeSubmit()}
                >
                  Submit
                </Button>
              )}
            </div>
          </Box>
        </Card>
      </Grid>
    </>
  )
}

export default Stack
